module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-1-89ea1462d7e37f27434d63309e8dae5e.png";